import { useMutation, useQuery } from "@tanstack/react-query";
import { AuthApiService } from "../../../apiService/auth-services";
import { loginPayload, ResponseType } from "../../../utils/types";
import NotificationService from "../../../services/NotificationService";

type useLoginType = {
    onSuccess: (data: any) => void;

};

export const useLogin = ({ onSuccess }: useLoginType) => {
    return useMutation<ResponseType, Error, loginPayload>({
        mutationFn: async (payload: loginPayload) => {
            const res = await AuthApiService.login(payload);
            if (!res.ok) {
                const message = res?.response?.message || "Invalid email or password";
                const error = Object.assign(new Error(message), { cause: res?.status });
                throw error;
            }
            return res;
        },
        onSuccess: (res: ResponseType) => {
            onSuccess(res.data);
        },
        onError: (err: any) => {
            const errorMessage = err?.message || "Invalid email or password";
            NotificationService.error(errorMessage);
        }
    });
};
